import medicarePro from "../../../Assets/image/medicarepro-banner.webp";
import cinemaproPoster from "../../../Assets/image/cinemapro.webp";
import doctorPoster from "../../../Assets/image/Doctor.webp";
import ddcetPoster from "../../../Assets/image/ddcet.webp";
import bizconnectPoster from "../../../Assets/image/bizconnect.webp";
import CP1 from "../../../Assets/image/CinemaPro/CP-1.webp";
import CP2 from "../../../Assets/image/CinemaPro/CP-2.webp";
import CP3 from "../../../Assets/image/CinemaPro/CP-3.webp";
import CP4 from "../../../Assets/image/CinemaPro/CP-4.webp";
import DR1 from "../../../Assets/image/DR/DR-1.webp";
import DR2 from "../../../Assets/image/DR/DR-2.webp";
import DR3 from "../../../Assets/image/DR/DR-3.webp";
import DR4 from "../../../Assets/image/DR/DR-4.webp";
import BC1 from "../../../Assets/image/bizconnect-gallary/BC-1.webp";
import BC2 from "../../../Assets/image/bizconnect-gallary/BC-2.webp";
import BC3 from "../../../Assets/image/bizconnect-gallary/BC-3.webp";
import BC4 from "../../../Assets/image/bizconnect-gallary/BC-4.webp";
import BC5 from "../../../Assets/image/bizconnect-gallary/BC-5.webp";
import BC6 from "../../../Assets/image/bizconnect-gallary/BC-6.webp";
import BC7 from "../../../Assets/image/bizconnect-gallary/BC-7.webp";
import DD1 from "../../../Assets/image/ddcet-gallary/DD-1.webp";
import DD2 from "../../../Assets/image/ddcet-gallary/DD-2.webp";
import DD3 from "../../../Assets/image/ddcet-gallary/DD-3.webp";
import DD4 from "../../../Assets/image/ddcet-gallary/DD-4.webp";
import DD5 from "../../../Assets/image/ddcet-gallary/DD-5.webp";

const product_data = [
  {
    id: 1,
    title: "CinemaPro",
    poster_imgs: [CP1, CP2, CP3, CP4],
    poster_img: cinemaproPoster,
    brief:
      "CinemaPro is a premium platform designed to help film industry professionals manage their projects seamlessly, offering tools for collaboration, scheduling, and production tracking.",
    description:
      "CinemaPro is a premium platform revolutionizing project management for the film industry. It streamlines collaboration, scheduling, and tracking, eliminating traditional complexities. With real-time updates, customizable dashboards, and powerful analytics, filmmakers can efficiently manage production timelines, budgets, and resources. Designed for security and scalability, CinemaPro adapts to both indie and large-scale productions, providing a seamless, data-driven workflow for modern filmmaking.",
    problem_statement:
      "The film industry faces inefficiencies due to fragmented workflows, scheduling conflicts, and budget overruns, leading to delays and miscommunication. CinemaPro streamlines production management with centralized coordination, real-time tracking, and better resource allocation.",
    challenges: [
      "Coordinating cast, crew, and locations in real-time was a nightmare.",
      "Budget tracking was chaotic, leading to frequent overruns.",
      "Manual call sheet creation slowed down production.",
      "Scattered data across tools caused inefficiencies and miscommunication.",
      "Ensuring security while managing multiple access levels was complex.",
    ],

    solutions: [
      "Automated scheduling syncs availability and updates instantly.",
      "Integrated budgeting tracks expenses and prevents overspending.",
      "Call sheets are auto-generated for accuracy and efficiency.",
      "A centralized database streamlines production data management.",
      "Encryption and role-based access ensure data security.",
    ],

    approach: [
      "Built a dynamic scheduling system to resolve conflicts automatically.",
      "Developed a real-time budgeting tool with alerts for overspending.",
      "Designed an automated call sheet generator for seamless distribution.",
      "Created a cloud-based database with powerful search and filtering.",
      "Implemented multi-level security protocols for safe data handling.",
    ],
    key_features: [
      {
        feature: "Location Management",
        description:
          "Store and organize shooting locations with essential details, including availability, permits, and contacts.",
      },
      {
        feature: "Artist & Crew Management",
        description:
          "Maintain detailed profiles of artists and crew members, including availability, assigned roles, and contact information.",
      },
      {
        feature: "Vendor Management",
        description:
          "Keep track of vendors for equipment, costumes, catering, and other production needs, ensuring seamless coordination.",
      },
      {
        feature: "Script Upload & Breakdown",
        description:
          "Upload scripts and automatically break them down by scene, identifying necessary props, locations, and characters.",
      },
      {
        feature: "Scene-Based Scheduling",
        description:
          "Plan and organize shoots efficiently by scheduling scenes based on actor availability, locations, and production needs.",
      },
      {
        feature: "Auto-Generated Call Sheets",
        description:
          "Automatically generate call sheets based on the production schedule, including key details like cast, crew, locations, and shooting times.",
      },
      {
        feature: "Budget & Expense Tracking",
        description:
          "Monitor expenses and manage budgets effectively to prevent overspending and ensure financial control.",
      },
      {
        feature: "Secure Cloud Storage",
        description:
          "Safely store production documents, scripts, schedules, and other essential files with encryption and role-based access.",
      },
    ],
    frontend: "React Js",
    backend: "Ruby on Rails",
    database: "PostgreSQL",
    primary_color: "#1d5b79",
    secondary_color: "#a9c8e2",
  },
  {
    id: 2,
    title: "MediCare Pro",
    poster_imgs: [DR1, DR2, DR3, DR4],
    poster_img: doctorPoster,
    brief:
      "Doctor is a comprehensive clinic management platform that streamlines patient care, appointment scheduling, billing, and medical records management, improving the overall healthcare experience.",
    description:
      "Medicare Pro is an advanced healthcare management platform that streamlines patient care and operations for clinics and hospitals. It integrates real-time communication, appointment scheduling, billing, and patient monitoring into a single, efficient system. With intelligent dashboards, automated workflows, and secure data management, it enhances accessibility, reduces administrative burdens, and ensures regulatory compliance. Scalable and user-friendly, Medicare Pro empowers medical professionals to focus on delivering quality patient care.",
    problem_statement:
      "The healthcare industry struggles with inefficiencies in patient-doctor communication, manual billing, prescription management, and real-time treatment tracking. Medicare Pro streamlines healthcare operations with centralized communication, automated billing, and intelligent patient monitoring for improved efficiency and patient care.",
    main_img: medicarePro,
    challenges: [
      "Patients faced long wait times for doctor consultations.",
      "Managing prescriptions and billing manually was inefficient.",
      "Tracking medicine inventory accurately was difficult.",
      "Monitoring patient treatment progress lacked real-time insights.",
      "Communicating important health updates to patients was challenging.",
    ],
    solutions: [
      "Real-time chat enables instant doctor-patient communication.",
      "Online billing and e-prescriptions streamline healthcare management.",
      "Automated inventory management ensures accurate stock tracking.",
      "Graphical analytics provide real-time treatment progress insights.",
      "Broadcasting system delivers important health updates instantly.",
    ],
    approach: [
      "Developed a secure, real-time chat system for doctor-patient interactions.",
      "Integrated an online billing and prescription management module.",
      "Built an intelligent inventory tracking system to prevent shortages.",
      "Designed a dashboard with treatment progress analytics for doctors.",
      "Implemented a notification system for quick health alerts and updates.",
    ],
    key_features: [
      {
        feature: "Real-Time Doctor-Patient Chat",
        description:
          "Enable seamless communication between doctors and patients with instant messaging for quick consultations and follow-ups.",
      },
      {
        feature: "Online Consulting",
        description:
          "Offer virtual consultations, allowing patients to connect with healthcare professionals from anywhere.",
      },
      {
        feature: "Online Billing & Prescription Handling",
        description:
          "Streamline the billing process and manage prescriptions digitally, ensuring a hassle-free experience for patients and healthcare providers.",
      },
      {
        feature: "Medicine Inventory Management",
        description:
          "Keep track of medicine stock levels, expiration dates, and availability to ensure smooth pharmacy operations.",
      },
      {
        feature: "Treatment Progress Analytics",
        description:
          "Provide analytical and graphical representation of a patient’s treatment progress for better monitoring and decision-making.",
      },
      {
        feature: "Broadcasting Important Messages",
        description:
          "Send urgent notifications and important updates to patients and healthcare staff in real time.",
      },
      {
        feature: "Free Health Surveys",
        description:
          "Conduct free online surveys to collect valuable patient feedback and assess public health trends.",
      },
      {
        feature: "Online Counseling",
        description:
          "Offer virtual mental health and wellness counseling sessions with professional therapists and counselors.",
      },
    ],
    frontend: "Vite(React JS)",
    backend: "Ruby on Rails",
    database: "PostgreSQL",
    primary_color: "#244A01",
    secondary_color: "#9E8914",
  },
  // {
  //   id: 3,
  //   title: "CineStore",
  //   main_img: cinestore,
  //   poster_img: cinestorePoster,

  //   brief:
  //     "CineStore is an innovative online marketplace that connects the film industry with vendors, crew, artists, and equipment rental services, offering a vast network for all production needs.",
  //   description:
  //     "CineStore is an innovative online marketplace designed for the film industry. It connects filmmakers with vendors, crew, artists, and equipment rental services. By streamlining access to essential resources, it simplifies production planning. Whether for small projects or large-scale films, CineStore has it covered. With a vast network of industry professionals, it ensures seamless collaboration and efficiency.",
  //   problem_statement:
  //     "Filmmakers often face challenges in sourcing trusted vendors, skilled crew, and essential equipment, leading to delays and inefficiencies. CineStore simplifies this by providing a seamless, all-in-one marketplace tailored for the industry. With its vast network, it ensures fast, reliable, and hassle-free production planning.",
  //   challenges: [
  //     "Finding reliable vendors, crew, and artists was time-consuming and uncertain.",
  //     "Coordinating equipment rentals and availability often led to scheduling conflicts.",
  //     "Production houses struggled to manage casting calls and auditions efficiently.",
  //     "Tracking communication between filmmakers, vendors, and crew was fragmented.",
  //     "Handling contracts, agreements, and document sharing securely was a challenge.",
  //   ],

  //   solutions: [
  //     "A verified marketplace connects filmmakers with trusted vendors, crew, and artists instantly.",
  //     "Smart scheduling ensures equipment rentals align with production timelines.",
  //     "A dedicated casting call system streamlines talent discovery and audition management.",
  //     "Built-in messaging and collaboration tools centralize communication in one place.",
  //     "Secure cloud storage with access controls simplifies document management.",
  //   ],

  //   approach: [
  //     "Developed a vetted network of industry professionals to ensure reliability.",
  //     "Built an intelligent rental coordination system to prevent scheduling conflicts.",
  //     "Designed an intuitive casting call platform for seamless auditions and talent acquisition.",
  //     "Integrated real-time messaging and project tracking for smooth collaboration.",
  //     "Implemented encrypted cloud storage with role-based access for secure file sharing.",
  //   ],
  //   key_features: [
  //     {
  //       feature: "Marketplace for Film Resources",
  //       description:
  //         "Connect with a vast network of vendors, crew members, artists, and equipment rental services to streamline production planning.",
  //     },
  //     {
  //       feature: "Crew & Talent Hiring",
  //       description:
  //         "Browse and hire experienced film professionals, including directors, cinematographers, editors, actors, and production crew members.",
  //     },
  //     {
  //       feature: "Equipment & Props Rental",
  //       description:
  //         "Easily find and rent cameras, lighting gear, sound equipment, props, and costumes from verified vendors.",
  //     },
  //     {
  //       feature: "Location Scouting & Booking",
  //       description:
  //         "Discover and book shooting locations with details on availability, permits, pricing, and amenities.",
  //     },
  //     {
  //       feature: "Seamless Collaboration with CinemaPro",
  //       description:
  //         "Through deep integration with CinemaPro, crew members, artists, and vendors can be directly added to production houses looking for talent and resources. Production houses can also send inquiries for equipment rentals, making collaboration effortless and efficient.",
  //     },
  //     {
  //       feature: "Casting Calls & Auditions",
  //       description:
  //         "Post and apply for casting calls, helping filmmakers find the right talent and artists discover new opportunities.",
  //     },
  //     {
  //       feature: "Production Asset Management",
  //       description:
  //         "Manage and track all production assets, including props, costumes, and equipment, ensuring efficient organization.",
  //     },
  //     {
  //       feature: "Collaboration & Messaging",
  //       description:
  //         "Communicate seamlessly with vendors, crew, and collaborators through built-in messaging and project discussion tools.",
  //     },
  //     {
  //       feature: "Secure Document Storage",
  //       description:
  //         "Store and share important production documents, contracts, and scripts securely with cloud-based access.",
  //     },
  //   ],
  //   frontend: "React Js",
  //   backend: "Ruby on Rails",
  //   database: "PostgreSQL",
  //   primary_color: "#1d5b79",
  //   secondary_color: "#a9c8e2",
  // },
  {
    id: 3,
    title: "DDCET",
    poster_imgs: [DD1, DD2, DD3, DD4, DD5],
    poster_img: ddcetPoster,
    brief:
      "Direct Diploma to Degree Common Entrance Test Prep Platform",
    description:
      "DDCET is a comprehensive, multi-tenant exam preparation platform designed for diploma students in Gujarat, India who are appearing for the DDCET (conducted by GTU - Gujarat Technological University) to secure admissions into 2nd-year degree engineering courses. The platform caters to individual self-studying students as well as educational institutions (diploma colleges and coaching classes).",
    problem_statement:
      "Diploma students lack structured, bilingual prep materials and mock tests aligned to GTU patterns. Educational institutes lack centralized performance trackers and customized test schedulers for their batches.",
    challenges: [
      "Providing bilingual notes and mock tests in English and Gujarati simultaneously.",
      "Implementing strict real-time mock exam environments simulating GTU conditions.",
      "Managing multi-tenant data structures for colleges, faculties, and student batches.",
      "Ensuring secure bulk licensing for coaching institutions.",
    ],
    solutions: [
      "Integrated bilingual toggle modes for study resources and question pools.",
      "Automated test modules with active online timers, full audit logs, and analytics.",
      "Created distinct portals for Super Admins, Org Admins, Faculty, and Students.",
      "Connected Razorpay gateways with dynamic portal access license codes.",
    ],
    approach: [
      "Developed a modular multi-portal directory supporting varying role credentials.",
      "Designed bilingual translation mappings for localized test preparations.",
      "Engineered progress graphs and batch reports using Recharts integrations.",
    ],
    key_features: [
      {
        feature: "Real Exam Mock Tests",
        description: "Simulates real-time exam conditions with actual GTU syllabus patterns (Physics, Chemistry, Aptitude, Maths)."
      },
      {
        feature: "Bilingual Study Material",
        description: "Curated learning resources available in both English and Gujarati (ગુજરાતી) scripts."
      },
      {
        feature: "B2B Admin & Faculty Portals",
        description: "Colleges can enroll students, create student batches, and assign custom mock exams."
      },
      {
        feature: "Performance Analytics",
        description: "Detailed dashboards tracking response times, accuracy percentages, and weak areas."
      },
      {
        feature: "Rewards & Leaderboards",
        description: "Gamified scoreboards and monetary reward incentives for top state-level rankers."
      },
      {
        feature: "Custom Test Builder",
        description: "Allows faculty to compile and schedule unique exam papers from a master question bank."
      },
      {
        feature: "Secure payment Gateways",
        description: "Safe and instant student subscription activation via integrated Razorpay payment nodes."
      },
      {
        feature: "Batch Performance Tracking",
        description: "Detailed dashboards for teachers and administrators to trace class-wide accuracy percentages and identify weak topic areas."
      }
    ],
    frontend: "React JS (v19) & Vite",
    backend: "Ruby on Rails",
    backend2: "Python",
    database: "PostgreSQL",
    primary_color: "#312E81",
    secondary_color: "#E8488A",
  },
  {
    id: 4,
    title: "BizConnect",
    poster_imgs: [BC1, BC2, BC3, BC4, BC5, BC6, BC7],
    poster_img: bizconnectPoster,
    brief:
      "Multi-Tenant B2B & B2C E-commerce Platform",
    description:
      "BizConnect is a comprehensive, multi-tenant B2B and B2C e-commerce platform allowing independent merchants to register, set up storefronts, and sell products directly to their customers (retail or wholesale) under their own unique slugs.",
    problem_statement:
      "Wholesalers and SME merchants struggle to configure digital storefronts with dynamic branding, tiered bulk pricing, and minimum order limits on a single, secure shared platform.",
    challenges: [
      "Enforcing store-specific theme colors and font layouts dynamically on a shared React code framework.",
      "Implementing dual retail/wholesale prices alongside minimum checkout requirements.",
      "Securing client logins without requiring complex password forms.",
    ],
    solutions: [
      "Utilized custom CSS variables to swap merchant primary/secondary branding styles on request.",
      "Integrated wholesale restrictions that validate minimum checkout totals and pricing tables.",
      "Constructed a passwordless authentication flow using OTPs via SMS/WhatsApp APIs.",
    ],
    approach: [
      "Created dynamic storefront layout templates selectable from the merchant manager console.",
      "Engineered flexible catalog structures supporting variants, tiered inventory, and wholesale lists.",
      "Built WhatsApp chat integration widgets for direct merchant-to-buyer correspondence.",
    ],
    key_features: [
      {
        feature: "Storefront Customization",
        description: "Choose layouts and customize branding styles, logo headers, and color variables dynamically."
      },
      {
        feature: "Dual B2B/B2C Pricing",
        description: "Display standard retail prices to end buyers and custom bulk pricing tables to verified wholesale clients."
      },
      {
        feature: "Passwordless OTP Logins",
        description: "SMS and WhatsApp OTP routing using 2Factor APIs for rapid, passwordless buyer onboarding."
      },
      {
        feature: "Automated GST Invoices",
        description: "Generate and email store-branded PDF checkout invoices containing verified GST tax splits."
      },
      {
        feature: "Pincode Delivery Manager",
        description: "Allow merchants to select specific delivery service zones and shipping fees."
      },
      {
        feature: "Merchant Command Center",
        description: "Rich analytics dashboard detailing inventory status, sales metrics, and active orders."
      },
      {
        feature: "Tiered Bulk Discounts",
        description: "Configure multi-level volume pricing triggers for wholesale items to incentivize bulk purchasing."
      },
      {
        feature: "WhatsApp Ordering Hub",
        description: "Direct widget support letting customers query product stocks and negotiate bulk quotes directly with merchant staff."
      }
    ],
    frontend: "React JS & Vite",
    backend: "Ruby on Rails",
    database: "PostgreSQL",
    primary_color: "#002d62",
    secondary_color: "#e5f0fa",
  },
];

export default product_data;
